import React, { forwardRef, ReactElement } from 'react';
import { Box } from '@mui/material';
import { getTemplate } from '../templates';
import { templateOrigin } from '../templates/zoneHitTest';
import TemplateArt from '../templates/art/TemplateArt';

export interface TemplateLayerProps {
  templateId: string;
  isDarkMode: boolean;
}

/**
 * Renders the retro template as a backmost decorative layer on the canvas.
 * Zone assignment for export uses the TS zone definitions, not this SVG.
 * The ref is forwarded to the root Box element for image export use.
 */
const TemplateLayer = forwardRef<HTMLDivElement, TemplateLayerProps>(
  function TemplateLayer({ templateId, isDarkMode }, ref): ReactElement | null {
    const template = getTemplate(templateId);
    if (!template) return null;

    const origin = templateOrigin(template);

    return (
      <Box
        ref={ref}
        sx={{
          position: 'absolute',
          left: origin.x,
          top: origin.y,
          width: template.size.width,
          height: template.size.height,
          pointerEvents: 'none',
          zIndex: 1,
          userSelect: 'none',
          // Do NOT set isolation: isolate here — that would confine the child
          // img's mix-blend-mode to this box instead of blending with the canvas.
          isolation: 'auto',
        }}
      >
        <TemplateArt templateId={templateId} isDarkMode={isDarkMode} />
      </Box>
    );
  },
);

export default TemplateLayer;
